'use strict';

/* eslint-enable */

// As this module gets injected into both ORB/Orbit, and bbccookies has
// different APIs in both environments, this module unifies the APIs by
// following the adapter pattern.
define('orb/lib/_script', function () {
  'use strict';

  var uid = 1; // unique scriptnode name identifier

  var exports = {
    inject: function (src) {
      var scriptEl;

      scriptEl = document.createElement('script');
      scriptEl.src = src;
      document.getElementsByTagName('head')[0].appendChild(scriptEl);

      return scriptEl;
    },
    /**
          @param {string} url The remote URL of the service providing the JSONP data.
          @param {function} callback The function to execute once the JSON has been unwrapped from its JSONP.
          @param {object} [opts] The options.
          @param {string} [opts.callbackName] The name of the JSONP function, defaults to "jsonpcb_#" where # is an incrementing number.
          @param {number} [opts.timeout] The number of milliseconds to wait before giving up (and calling the error function, if one is given).
          @param {function} [opts.error] The function to call if the JSONP request times out.
       */
    jsonp: function (url, callback, opts) {
      var key;
      var script;
      var timer;
      var timedOut = false;

      opts = opts || {};

      key = opts.callbackName ? opts.callbackName : 'jsonpcb' + (uid++);

      if (opts.timeout) {
        timer = setTimeout(function () {
          timedOut = true;
          if (opts.error) {
            opts.error();
          }
        }, opts.timeout);
      }

      var keyParts = key.split('.');
      var child = keyParts[keyParts.length-1];
      var parent = window;
      for (var i = 0, l = keyParts.length; i < l-1; i++) {
        parent = parent[keyParts[i]];
      }

      parent[child] = function (data) {
        clearTimeout(timer);
        if (!timedOut) {
          callback(data);
        }
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
        parent[child] = undefined;
      };

      script = exports.inject(url + (url.indexOf('?') === -1 ? '?' : '&') + 'callback=' + key);
    }
  };

  return exports;
});


define('orb/cookies-adapter', ['orb/cookies'], function (cookies) {

  function optAllCookiesOrb(enabled) {
    // Cookie Oven is Orbit Only. Set single domain if not Orbit.
    cookies._setPolicy('ads', enabled);
    cookies._setPolicy('personalisation', enabled);
    cookies._setPolicy('performance', enabled);
    return cookies._setPolicy('necessary', enabled);
  }

  return {
    isOrbitEnvironment: function () {
      // eslint-disable-next-line no-undef
      return (typeof bbccookies === 'object' && typeof bbccookies._getCookieName !== 'function');
    },

    IMPLICIT_FLAG : bbccookies.IMPLICIT_FLAG,
    EXPLICIT_FLAG : bbccookies.EXPLICIT_FLAG,
    EXPLICIT_FLAG_EU : bbccookies.EXPLICIT_FLAG_EU,
    PRIVACY_COOKIE_NAME : bbccookies.PRIVACY_COOKIE_NAME,
    EXPLICIT_COOKIE_NAME : bbccookies.EXPLICIT_COOKIE_NAME,
    POLICY_COOKIE_NAME : bbccookies.POLICY_COOKIE_NAME,
    CURRENT_PRIVACY_POLICY : bbccookies.CURRENT_PRIVACY_POLICY,

    isEU : bbccookies.isEU,

    set: function (key, value) {
      var onHttps = document.location.protocol === 'https:';
      var nextYear = new Date();
      nextYear.setYear(nextYear.getFullYear() + 1);

      if (this.isOrbitEnvironment()) {
        return cookies.set(key, value, {
          domain: cookies._getCurrentDomain(),
          path: '/',
          expires: nextYear,
          sameSite: 'None',
          secure: onHttps
        });
      }

      var matches = window.location.host.match(/(.bbc(?:\.co\.uk))(:\d+)?(\/.*)?$/i);
      var domain = (matches && matches[1] === '.bbc.co.uk') ? '.bbc.co.uk': '.bbc.com';

      var cookieString = key + '='+value+';'
        + 'domain='+domain+';'
        + 'path=/;'
        + 'expires=' + nextYear.toUTCString() + ';'
        + 'sameSite=None;'
        + 'secure=' + onHttps + ';';
      return cookies.set(cookieString);
    },

    get: function (key) {
      if (this.isOrbitEnvironment()) {
        return cookies.get(key);
      }
      return cookies.getCrumb(key);
    },

    copyPolicyCookiesCrossDomain: function (done) {
      if (this.isOrbitEnvironment()) {
        return cookies.copyPolicyCookiesCrossDomain(done);
      }
      // Cookie Oven is Orbit Only, so in case of ORB, just call the callback `done()`
      done();
    },

    setDefaultCookiesSingleDomain: function () {
      if (this.isOrbitEnvironment()) {
        return cookies.setDefaultCookiesSingleDomain();
      }
      return optAllCookiesOrb(false);
    },

    setDefaultCookiesCrossDomain: function () {
      if (this.isOrbitEnvironment()) {
        return cookies.setDefaultCookiesCrossDomain();
      }
      return optAllCookiesOrb(false);
    },

    setExplicitCookiesCrossDomain: function (explicit) {
      if (this.isOrbitEnvironment()) {
        return cookies.setCookieExplicitCrossDomain(explicit);
      }
      return false;
    },

    optInToAllCookiesCrossDomain: function () {
      if (this.isOrbitEnvironment()) {
        var newCookiePolicy = {
          ads:true,
          personalisation:true,
          performance: true,
          necessary:true
        };
        return cookies.setCookiePolicyCrossDomain(newCookiePolicy);
      }
      return optAllCookiesOrb(true);
    },

    isCookiePolicySet: function () {
      if (this.isOrbitEnvironment()) {
        return cookies.isCookiePolicySet();
      }
      return this.get('ckns_policy') !== null;
    },

    //given ORB is now frozen, we have not implemented equivalent logic
    //using the ORB version of the cookie library as has been done above
    setImplicitPolicy: cookies.setImplicitPolicy
  };
});

require(['orb/lib/_script', 'orb/cookies-adapter'], function (script, cookies) {

  var COOKIE_PROMPT_CLASS_NAMES = '';
  var COOKIE_PROMPT_CLASS_NAMES_FULL_SCREEN_OVERLAY = 'full-screen full-screen-bottom full-screen-overlay';
  var COOKIE_PROMPT_CLASS_NAMES_FULL_SCREEN = 'full-screen';

  // some pages require that we do not add the overlay to the fullscreen cookie banner,
  // because the user needs to interact with the page before accepting cookies
  // (e.g. the cookie settings page)
  // the page name is checked against this list

  var PAGES_WITHOUT_FULLSCREEN_BANNER_OVERLAY = ['usingthebbc.'];

  function getExplicitConsentFlag() {
    return cookies.get(cookies.EXPLICIT_COOKIE_NAME);
  }

  function policyIsExplicit(region) {
    var policy = getExplicitConsentFlag();
    if (policy === null) {
      return false;
    }
    if (region === 'gb' || region === 'row') {
      return policy >= cookies.EXPLICIT_FLAG;
    }
    if (region === 'eu') {
      return policy === cookies.EXPLICIT_FLAG_EU;
    }
    throw new Error("region not recognised: " + region);
  }

  function showPrivacyBanner(container, privacyPromptElement, cookiePromptElement) {
    privacyPromptElement.style.display = 'block';
    cookiePromptElement.style.display = 'none';
    container.className = COOKIE_PROMPT_CLASS_NAMES;
  }

  function hideAllBanners(container, privacyPromptElement, cookiePromptElement) {
    privacyPromptElement.style.display = 'none';
    cookiePromptElement.style.display = 'none';
    container.className = COOKIE_PROMPT_CLASS_NAMES;
  }

  // This returns appropriate urlPrefix based on whether the page belongs to ORB or Orbit.
  function getUrlPrefix() {
    var urlPrefix = 'https://bbc.com';
    var matches = window.location.host.match(/(bbc(?:\.co\.uk))(:\d+)?(\/.*)?$/i);
    if (matches && matches[1] === 'bbc.co.uk') {
      urlPrefix = urlPrefix.replace('bbc.com', 'bbc.co.uk');
    }
    return urlPrefix;
  }

  function showCookieBannerIfPolicyNotExplicit(container, privacyPrompt, cookiePrompt, region, pageName) {
    if (policyIsExplicit(region)) {
      return;
    }

    function getClassName(pageName) {
      var pages = PAGES_WITHOUT_FULLSCREEN_BANNER_OVERLAY;
      for (var i=0; i<pages.length; i++) {
        if (pageName.search(pages[i]) > -1) {
          return COOKIE_PROMPT_CLASS_NAMES_FULL_SCREEN;
        }
      }
      return COOKIE_PROMPT_CLASS_NAMES_FULL_SCREEN_OVERLAY;
    }

    var fullScreen = region === 'eu';
    var fullScreenClassName = getClassName(pageName);

    privacyPrompt.style.display = 'none';
    cookiePrompt.style.display = 'block';
    container.className = fullScreen ? fullScreenClassName : COOKIE_PROMPT_CLASS_NAMES;
  }

  function initialiseBanners(region, pageName) {
    var container = document.getElementById('cookiePrompt');
    var privacyPrompt = document.getElementById('bbcprivacy');
    var cookiePrompt = document.getElementById('bbccookies');
    var privacyContinueButton = document.getElementById('bbcprivacy-continue-button');

    privacyContinueButton.addEventListener('click', function () {
      hideAllBanners(container, privacyPrompt, cookiePrompt);
      showCookieBannerIfPolicyNotExplicit(container, privacyPrompt, cookiePrompt, region, pageName);
    });

    var cookieContinueButton = document.getElementById('bbccookies-continue-button');

    cookieContinueButton.addEventListener('click', function () {
      hideAllBanners(container, privacyPrompt, cookiePrompt);

      cookies.optInToAllCookiesCrossDomain();
      if (region === 'gb') {
        cookies.set(cookies.EXPLICIT_COOKIE_NAME, cookies.EXPLICIT_FLAG);
        cookies.setExplicitCookiesCrossDomain(cookies.EXPLICIT_FLAG);
      }
      if (region === 'eu') {
        cookies.set(cookies.EXPLICIT_COOKIE_NAME, cookies.EXPLICIT_FLAG_EU);
        cookies.setExplicitCookiesCrossDomain(cookies.EXPLICIT_FLAG_EU);
      }
    });

    var cookieSettingsLink = document.getElementById('bbccookies-settings')
      .getElementsByTagName('a')[0];

    cookieSettingsLink.addEventListener('click', (function () {
      var clicked = false;

      return function (event) {
        if (!clicked) {
          cookies.copyPolicyCookiesCrossDomain(function () {
            clicked = true;
            //'re-click' the link to trigger the suppressed navigation
            //and cause istats to fire; it relies on the propagated click event
            cookieSettingsLink.click();
          });
          if (region === 'gb') {
            cookies.set(cookies.EXPLICIT_COOKIE_NAME, cookies.EXPLICIT_FLAG);
            cookies.setExplicitCookiesCrossDomain(cookies.EXPLICIT_FLAG);
          }
          if (region === 'eu') {
            cookies.set(cookies.EXPLICIT_COOKIE_NAME, cookies.EXPLICIT_FLAG_EU);
            cookies.setExplicitCookiesCrossDomain(cookies.EXPLICIT_FLAG_EU);
          }
          //suppress the initial navigation
          event.preventDefault();
        }
      };

    })());

    var seenPrivacyBanner = (cookies.get(cookies.PRIVACY_COOKIE_NAME) === cookies.CURRENT_PRIVACY_POLICY);
    showCookieBannerIfPolicyNotExplicit(container, privacyPrompt, cookiePrompt, region, pageName);

    if (!seenPrivacyBanner) {
      showPrivacyBanner(container, privacyPrompt, cookiePrompt);
      cookies.set(cookies.PRIVACY_COOKIE_NAME, cookies.CURRENT_PRIVACY_POLICY);
    } else {
      showCookieBannerIfPolicyNotExplicit(container, privacyPrompt, cookiePrompt, region, pageName);
    }
  }

  function getSanitisedLanguage(locale) {
    var lang = 'en';

    if (typeof(locale) === 'string' && locale.length >= 2) {
      lang = locale.trim().substring(0, 2).toLowerCase();
    }

    var localeIsSupported = ['en', 'cy', 'gd', 'ga'].indexOf(lang) !== -1;

    if (!localeIsSupported) {
      return 'en';
    }
    return lang;
  }

  function loadContentOfBanners(locale, initialiseBanners, region, pageName) {
    var lang = getSanitisedLanguage(locale);

    var CSS_URL = window.COOKIES_STATIC_HOST + 'bbccookies.min.css';
    var url = window.COOKIES_STATIC_HOST + lang + '.min.js';
    window.bbcpage.loadCSS(CSS_URL).then(function () {
      script.jsonp(
        url,
        function (template) {
          var parsedHTML = template.replace(/<<bbcUrlPrefix>>/g, getUrlPrefix());
          document.getElementById('cookiePrompt').innerHTML = parsedHTML;

          var elements = document.querySelectorAll('[data-region-filter]');
          for (var i=0; i<elements.length; i++) {
            var el = elements[i];
            if (el.getAttribute('data-region-filter') !== region) {
              el.style.display = 'none';
            }
          }

          initialiseBanners(region, pageName);
        },
        {
          callbackName: 'cookiePrompt'
        }
      );
    });
  }

  Promise.all([
    window.bbcuser.isUKCombined(),
    window.bbcuser.getCountry(),
    window.bbcpage.getLanguage(),
    window.bbcpage.getName()
  ]).then(function (conditions) {

    var isUK = conditions[0];
    var countryCode = conditions[1];
    var language = conditions[2];
    var pageName = conditions[3];

    var isEU = cookies.isEU(countryCode);

    var region;

    if(isUK) {
      region = 'gb';
    } else if(isEU){
      region = 'eu';
    } else {
      region = 'row';
    }

    if (!policyIsExplicit(region)) {
      cookies.set(cookies.EXPLICIT_COOKIE_NAME, cookies.IMPLICIT_FLAG);
      cookies.setImplicitPolicy(region);
    }

    if(region === 'gb' || region === 'eu') {
      var seenPrivacyBanner = (cookies.get(cookies.PRIVACY_COOKIE_NAME) === cookies.CURRENT_PRIVACY_POLICY);
      if (!seenPrivacyBanner || !policyIsExplicit(region)) {
        loadContentOfBanners(language, initialiseBanners, region, pageName);
      }
    }
  })
  .catch(function (error) {
    loadContentOfBanners('en', initialiseBanners, 'gb', '');
  });
});
